"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyWorkWithUs() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const reasons = ["Technical depth from R&D to commercialization", "Fast, practical execution built around real-world constraints", "Confidential and collaborative partnerships", "Experience across materials, processes, and product systems"];
  return <section className="relative bg-dark-background py-24 px-6 lg:px-8">
      <div className="mx-auto max-w-4xl text-center">
        <div ref={headingRef} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${headingVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-sans text-4xl font-bold tracking-tight text-foreground-dark sm:text-5xl lg:text-6xl">
            Why Work With Us
          </h2>
        </div>

        <div ref={textRef} className={`mt-12 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] delay-100 ${textVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <ul className="space-y-6 text-left max-w-2xl mx-auto">
            {reasons.map((reason, i) => <li key={i} data-index={i} className="flex items-start gap-4 text-lg leading-relaxed text-foreground-dark/90 sm:text-xl">
                <span className="flex-shrink-0 mt-1.5 w-2 h-2 rounded-full bg-accent"></span>
                <span>{reason}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}